module.exports = __webpack_public_path__ + "static/media/brain.42003a6e.png";